import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('usercentrics-dialog', () => import(/* webpackMode: "lazy" */'./usercentrics-dialog'));
